//Returns the proper class depending on if the page is the active current page.
export const getPageClassName = (
	page: number,
	currentPage: number,
	className: string,
) => {
	if (page === currentPage) {
		return className + " active";
	}

	return className;
};
